var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { __decorate, __metadata } from "tslib";
import chmService from "@/core/services/chmService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Seguidor_ChamadoActions } from "@/store/enums/chmEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Seguidor_ChamadoModule = class Seguidor_ChamadoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Seguidor_ChamadoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            chmService.getFile("Seguidor_Chamado/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Seguidor_Chamado.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Seguidor_ChamadoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            chmService.postFile("Seguidor_Chamado/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Seguidor_ChamadoActions.POST_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.post("Seguidor_Chamado/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Seguidor_ChamadoActions.PUT_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.put("Seguidor_Chamado/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Seguidor_ChamadoActions.DELETE_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.delete("Seguidor_Chamado/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Seguidor_ChamadoActions.DELETE_RANGE_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.delete("Seguidor_Chamado/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Seguidor_ChamadoActions.FILTER_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.post("Seguidor_Chamado/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Seguidor_ChamadoActions.GET_SEGUIDOR_CHAMADO]() {
        return new Promise(resolve => {
            chmService.get("Seguidor_Chamado/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Seguidor_ChamadoActions.GETWITHDISABLED_SEGUIDOR_CHAMADO]() {
        return new Promise(resolve => {
            chmService.get("Seguidor_Chamado/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Seguidor_ChamadoActions.GET_BY_ID_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.get("Seguidor_Chamado/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_l = Seguidor_ChamadoActions.TOGGLE_SEGUIDOR_CHAMADO](data) {
        return new Promise(resolve => {
            chmService.get("Seguidor_Chamado/ToggleSeguidorChamado", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Seguidor_ChamadoModule.prototype, _l, null);
Seguidor_ChamadoModule = __decorate([
    Module
], Seguidor_ChamadoModule);
export default Seguidor_ChamadoModule;
//# sourceMappingURL=Seguidor_ChamadoModule.js.map